// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"de8db045","192":"9c0d7c1f"}[chunkId] + ".chunk.js";
};